export default "__VITE_ASSET__XM$6HOYP__"